<template>
  <b-button
    class="shadow rounded font-display flex items-center border-2 transition hover:shadow-xl justify-center"
    :class="classes"
    :disabled="disabled || loading"
    :loading="loading"
    :icon-right="iconRight"
    :icon-left="iconLeft"
  >
    <span v-text="text"></span>
  </b-button>
</template>

<script>
export default {
  props: {
    text: { required: false },
    iconRight: { required: false },
    iconLeft: { required: false },
    outlined: { default: false },
    loading: { default: false },
    disabled: { default: false },
    size: { required: false },
    color: { default: "primary-500" },
    textColor: { default: "neutral-100" },
    iconSize: { default: "5" },
  },
  computed: {
    classes() {
      return [
        this.outlinedClasses,
        this.backgroundClasses,
        this.textColorClasses,
        {
          "bg-neutral-600 border-neutral-600": this.disabled && !this.outlined,
          "border-neutral-600": this.disabled && this.outlined,
          "px-3 py-2": !this.size,
          "px-2 py-1 text-sm": this.size === "small",
          "px-4 py-3": this.size === "large",
          "px-6 py-5": this.size === "x-large",
          "pointer-events-none": this.disabled,
        },
      ];
    },
    outlinedClasses() {
      return this.outlined && !this.disabled
        ? `text-${this.color} border-${this.color}`
        : "";
    },
    backgroundClasses() {
      return !this.outlined && !this.disabled
        ? `bg-${this.color} border-${this.color}`
        : "";
    },
    textColorClasses() {
      return !this.outlined ? `text-${this.textColor}` : "";
    },
  },
};
</script>
